// Official Oasys Academy logo (provided by client).
// Yellow brand tile with monogram + "Oasys Academy" wordmark.
// Always render as a single asset — never recolor or recompose.
export const OASYS_LOGO_URL =
  "https://customer-assets.emergentagent.com/job_oasys-academy/artifacts/0u8eo5ju_academy%20logo.jpg";

export const Logo = ({ size = "md", className = "", priority = false }) => {
  const dims = {
    sm: "h-9 md:h-10",
    md: "h-11 md:h-12",
    lg: "h-16 md:h-20",
    xl: "h-24 md:h-28",
  };
  return (
    <img
      src={OASYS_LOGO_URL}
      alt="Oasys Academy"
      width="240"
      height="240"
      loading={priority ? "eager" : "lazy"}
      className={`${dims[size] || dims.md} w-auto block select-none ${className}`}
      draggable={false}
    />
  );
};
